<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToGap'
});
</script>
<template>
	<div class="to-gap" :flex="flex ? flex : null" :style="setStyle" :class="setClass"></div>
</template>
<script setup lang="ts">
import { computed, CSSProperties } from 'vue'



const props = defineProps({
	flex: Boolean,
	mode: {
		type: String,
		default: 'default'
	},
	value: {
		type: [String, Number],
		default: ''
	},
	inline: {
		type: Boolean,
		default: false
	}
})

const setStyle = computed((): CSSProperties => {
	const obj: CSSProperties = {}
	if (props.value && Number(props.value) !== -1) {
		if (props.inline) {
			if (!isNaN(Number(props.value))) {
				obj.width = props.value + 'em'
			} else {
				obj.width = props.value
			}
		} else {
			if (!isNaN(Number(props.value))) {
				obj.height = props.value + 'em'
			} else {
				obj.height = props.value
			}
		}
	}
	return obj
})
const setClass = computed(() => {
	let arr: string[] = []
	if (props.mode) {
		arr.push(`mode-${props.mode}`)
	}
	if (props.inline) {
		arr.push(`is-inline`)
	}
	if (Number(props.value) === -1) {
		arr.push('is-close')
	}
	return arr
})
</script>
